<template>
  <div>
    <div>
      <div>
        <b-button-toolbar
          key-nav
          class="group-botton mb-2"
          aria-label="Toolbar with button groups"
        >
          <b-button-group class="move-button mr-1" size="sm">
            <b-button class="color-button" @click="buttonRight(700)"
              >&laquo;</b-button
            >
            <b-button class="color-button" @click="buttonRight(200)"
              >&lsaquo;</b-button
            >
          </b-button-group>
          <div class="hidden-button">
            <b-button-group id="area-button" size="sm">
              <b-button
                v-for="(p, index) in permissions"
                :key="index"
                :disabled="waiting"
                :class="{
                  'color-button': true,
                  'selectable-button': true,
                  'active-button':
                    user.Permissions[p].parameter == unitSelected,
                }"
                :title="user.Permissions[p].tooltip"
                @click="updateGrid(user.Permissions[p].parameter)"
              >
                <span>{{
                  user.Permissions[p].permission.toUpperCase()
                }}</span></b-button
              >
            </b-button-group>
          </div>
          <b-button-group class="move-button ml-1" size="sm">
            <b-button class="color-button" @click="buttonLeft(200)"
              >&rsaquo;</b-button
            >
            <b-button class="color-button" @click="buttonLeft(700)"
              >&raquo;</b-button
            >
          </b-button-group>
        </b-button-toolbar>

        <div  id="table-harvest-plan" class="sample1 grid middle"></div>

        <div class="row">
          <div class="rowItem txtRevision" lg="3" md="4" sm="12">
            <div>{{ $t('ultima-revisao') }}{{ json.revision | dateBR }}</div>
          </div>

          <div class="ybase rowItem yearSelector" xl="3" lg="3" md="4" sm="6">
            <label for="jsonBaseYear" style="width: 120px; margin: 0px">
              {{ $t('ano-base') }} </label>
            <b-form-spinbutton
              class="spinbutton-pentagro jsonBaseYear"
              id="jsonBaseYear"
              v-model="json.baseYear"
              min="2013"
              max="2050"
              step="1"
            >
            </b-form-spinbutton>
          </div>

          <div class="rowItem dates" xl="1" lg="3" md="3" sm="3">
            <div>{{ $t('data-inicial') }}</div>
            <date-picker
              id="date-picker"
              class="adjustDatePickers"
              ref="datePickerStart"
              name="date"
              v-model="json.initialDate"
              :config="optionsDatePicker"
            ></date-picker>
            <div>{{ $t('data-final') }}</div>
            <date-picker
              id="date-picker"
              class="adjustDatePickers"
              ref="datePickerStart"
              name="date"
              v-model="json.finalDate"
              :config="optionsDatePicker"
            ></date-picker>
            <div class="label-start-week">{{ $t('inicio-semana') }}</div>
            <b-form-select id="select-start-week" class="select-start-week" v-model="json.beginWeek" :options="options"></b-form-select>
          </div>
          
          
          <div class="gridBtGroup rowItem buttons" xl="1" lg="3" md="3" sm="3">
            <img
              src="@/assets/salvar.png"
              alt="salvar"
              style="margin-left: 30px; height: 38px"
              :title="$t('save')"
              @click="sendPlan($event)"
            />
            <img
              src="@/assets/cancel.png"
              alt="cancelar"
              style="margin-left: 30px; height: 38px"
              :title="$t('cancel')"
              @click="$bvModal.show('confirmPlanRestore')"
            />
          </div>
        </div>
      </div>
      <b-modal
        id="confirmPlanRestore"
        ok-variant="danger"
        :ok-title="$t('yes')"
        :cancel-title="$t('no')"
        @ok="reset"
        >{{ $t('confirma-o-descarte-das-alteracoes') }}</b-modal
      >
    </div>
  </div>
</template>

<script>
import * as moment from "moment";
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { urlMainAPI, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import axios from "axios";
import { NumberFormat } from "../flowchart/utils/tools";
import { showError } from "../../global";

export default {
  name: "GridPlan",
  components: { ...cGridAll },
  computed: mapState(["msg", "user"]),
  props: ["unit", "plan"],
  data: function () {
    return {
      waiting: false,
      temp: [],
      options:[
        {value: undefined, text: this.$t('selecione-o-inicio-da-semana'), disabled: true},
        {value: 1, text: this.$t('segunda-feira')},
        {value: 2, text: this.$t('terca-feira')},
        {value: 3, text: this.$t('quarta-feira')},
        {value: 4, text: this.$t('quinta-feira')},
        {value: 5, text: this.$t('sexta-feira')},
        {value: 6, text: this.$t('sabado')},
        {value: 7, text: this.$t('domingo')}
      ],
      permissions: [],
      unitSelected: "",
      json: {
        baseYear: new Date().getFullYear(),
        revision: "--/--/----",
        initialDate: moment().add(-365, "days").format("DD/MM/YYYY"),
        finalDate: moment().format("DD/MM/YYYY"),
        header: [],
        table: [],
        beginWeek: 1
      },
      ctrButton: {
        lengthMax: 10000,
        currentSlip: 0,
        offsetWidth: 0,
      },
      optionsDatePicker: {
        locale: moment.locale("pt-br"),
        format: "DD/MM/YYYY",
        extraFormats: ["DD/MM/YYYY HH:mm:ss", "YYYY/MM/DD HH:mm:ss", "x"],
        dayViewHeaderFormat: "MMMM/YYYY",
        allowInputToggle: true,
        useCurrent: false,
        showTodayButton: true,
        showClear: true,
        showClose: true,
        sideBySide: false,
        inline: false,
        keepOpen: false,
        tooltips: {
          today: this.$t('hoje'),
          clear: this.$t('limpar'),
          close: this.$t('fechar'),
          selectMonth: this.$t('selecionar-mes'),
          prevMonth: this.$t('mes-anterior'),
          nextMonth: this.$t('proximo-mes'),
          selectYear: this.$t('selecionar-ano'),
          prevYear: this.$t('ano-anterior'),
          nextYear: this.$t('proximo-ano'),
          selectDecade: this.$t('selecionar-decada'),
          prevDecade: this.$t('decada-anterior'),
          nextDecade: this.$t('proxima-decada'),
          prevCentury: this.$t('seculo-anterior'),
          nextCentury: this.$t('proximo-seculo'),
        },
      },
    };
  },
  filters: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      dateBr = dateBr.split(" ")[0];
      if (dateBr == "Invalid") {
        return "Aguardando dados ...";
      } else {
        return dateBr;
      }
    },
  },

  watch: {
    plan() {
      this.loadButtonUnits();
      this.loadPlan();
    },
  },

  methods: {
    onClickRecord(rec) {
      alert(JSON.stringify(rec));
    },

    loadPlan() {
      defaultSuccess(this.$t('carregando-dados-0'));
      const url = `${urlMainAPI}/getproductionplan/${this.unitSelected}`;
      (this.waiting = true),
        axios
          .get(url)
          .then((res) => {
            this.json = res.data;
            this.json.initialDate = moment(this.json.initialDate);
            this.json.finalDate = moment(this.json.finalDate);
            this.temp = JSON.parse(JSON.stringify(this.json));
            this.setGrid();
            this.waiting = false;
             defaultSuccess(this.$t('dados-carregados'));
            setTimeout(() => {
              this.$store.commit("setMsg", " ");
            }, 5000);
          })
          .catch((err) => {
            console.log(err);
            this.waiting = false;
          });
    },

    updateZero1e6(array) {
      array.table.forEach((a) => {
        Object.keys(a).forEach((item) => {
          if (a[item]) {
            if (parseFloat(a[item].replace(/\./g, "").replace(/,/, ".")) == 0) {
              a[item] = "0,000001";
            }
          }
        });
      });
    },

    updateZero(array) {
      array.forEach((r) => {
        Object.keys(r).forEach((t) => {
          if (r[t]) {
            if (String(r[t]).match(/[\d]/g)) r[t] = NumberFormat(r[t]);
          }
        });
      });
    },

    // eslint-disable-next-line no-unused-vars
    sendPlan: function (e) {
      if (!this.json.initialDate) {
        showError(this.$t('por-favor-insira-uma-data-inicial-valida'));
        return;
      }
      if (!this.json.finalDate) {
        showError(this.$t('por-favor-insira-uma-data-final-valida'));
        return;
      }
      if(!this.json.beginWeek){
        showError(this.$t('por-favor-selecione-o-dia-do-inicio-da-semana'))
      }

      this.updateZero1e6(this.json);

      let t1 = moment(this.json.initialDate, [
        "DD/MM/YYYY",
        "YYYY-MM-DD",
      ]).clone();
      let t2 = moment(this.json.finalDate, [
        "DD/MM/YYYY",
        "YYYY-MM-DD",
      ]).clone();
      t1 = t1.format("YYYY-MM-DD");
      t2 = t2.format("YYYY-MM-DD");

      let t1Compare = new Date(t1).getTime();
      let t2Compare = new Date(t2).getTime();

      if (t1Compare > t2Compare) {
        showError(this.$t('a-data-inicial-deve-ser-anterior-a-data-final'));
        return;
      }

      let updatedPlan = JSON.parse(JSON.stringify(this.json));
      updatedPlan.initialDate = t1;
      updatedPlan.finalDate = t2;

      let oldPlan = JSON.parse(JSON.stringify(this.temp));


      let payload = {
        oldPlan: oldPlan,
        updatedPlan: updatedPlan,
      };



      defaultSuccess(this.$t('salvando-dados'))
      this.waiting = true;
      const url = `${urlMainAPI}/saveproductionplan/${this.unitSelected}`;

      axios
        .post(url, payload)
        .then((res) => {
          this.waiting = false;
          defaultSuccess(res.data);
          (this.json.initialDate = moment(updatedPlan.initialDate)),
            (this.json.finalDate = moment(updatedPlan.finalDate)),
            this.updateZero(this.json.table);
          this.json.revision = new Date(Date.now());

          this.temp = JSON.parse(JSON.stringify(this.json));
        })
        .catch((err) => {
          console.log(err);
          this.waiting = false;
          this.updateZero(this.json.table);
        });
    },

    reset() {
      this.json = JSON.parse(JSON.stringify(this.temp));
      this.setGrid(this.json.header, this.json.table);
      defaultSuccess(this.$t('alteracoes-descartadas'));
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.json.header,
      });
      grid.records = this.json.table;
      this.setGrid = function (
        header = this.json.header,
        table = this.json.table
      ) {
        this.updateZero(table);
        grid.header = header;
        grid.records = table;
      };
    },

    loadButtonUnits() {
      this.permissions = [];
      let perm = new Array();
      Object.keys(this.user.Permissions).forEach((p) => {
        if (this.user.Permissions[p].permission != "") {
          let isBudget =
            this.plan == "BD" &&
            p.includes("gerenciarplanobudget") &&
            this.user.Permissions[p].allowed;

          let isPlan =
            this.plan == "PD" &&
            p.includes("gerenciarplanosafra") &&
            this.user.Permissions[p].allowed;

          if (isBudget) perm.push(p);
          else if (isPlan) perm.push(p);
        }
      });

      this.permissions = perm.sort();
      let u = this.permissions[0];
      //this.permissions.push(this.permissions[0],this.permissions[1],this.permissions[2],this.permissions[3],this.permissions[4])
      //this.permissions.push(this.permissions[0],this.permissions[1],this.permissions[2],this.permissions[3],this.permissions[4])
      this.unitSelected = this.user.Permissions[u].parameter;
      this.$emit("unit", this.unitSelected.split("-")[0]);
    },

    updateGrid(paramiter) {
      this.unitSelected = paramiter;
      this.$emit("unit", paramiter.split("-")[0]);
      this.loadPlan();
    },

    buttonLeft(step) {
      if (
        this.ctrButton.lengthMax <=
        this.ctrButton.currentSlip + this.ctrButton.offsetWidth + step
      ) {
        document.querySelector("#area-button").style["margin-left"] = `-${
          this.ctrButton.lengthMax - this.ctrButton.offsetWidth
        }px`;
        return;
      }

      if (
        this.ctrButton.lengthMax >=
        this.ctrButton.currentSlip + this.ctrButton.offsetWidth
      ) {
        this.ctrButton.currentSlip += step;
        document.querySelector("#area-button").style[
          "margin-left"
        ] = `-${this.ctrButton.currentSlip}px`;
      }
    },

    buttonRight(step) {
      if (this.ctrButton.currentSlip - step < 0)
        step = this.ctrButton.currentSlip;

      if (this.ctrButton.currentSlip >= 0) {
        this.ctrButton.currentSlip -= step;
        document.querySelector("#area-button").style[
          "margin-left"
        ] = `-${this.ctrButton.currentSlip}px`;
      }
    },

    configButtons() {
      this.ctrButton.offsetWidth =
        document.querySelector(".hidden-button").offsetWidth;
      this.ctrButton.lengthMax =
        document.querySelector("#area-button").offsetWidth;

      if (this.ctrButton.lengthMax < this.ctrButton.offsetWidth) {
        document.querySelector(".group-botton").style.display = "flex";
        document.getElementsByClassName("move-button")[0].style.display =
          "none";
        document.getElementsByClassName("move-button")[1].style.display =
          "none";
      }
    },
  },

  created() {
    this.json.initialDate = moment().clone().format("DD/MM/YYYY");
    this.json.finalDate = moment().clone().format("DD/MM/YYYY");
    this.loadButtonUnits();
    this.loadPlan();
  },

  mounted() {
    this.createGrid();
    this.configButtons();
  },
};
</script>

<style scoped>
.dates {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dates div {
  margin: 0 3% 0 3%;
}

.dates select,

.dates input {
  max-width: 25em;
  text-align: center;
}

.grid {
  height: calc(80vh - 215px);
  width: 98.5%;
  margin: auto auto;
  border: solid 1px rgba(0, 0, 0, 0.26);
}

.row {
  display: grid;
  grid-template-columns: 22% 15% 52% 11%;
  margin: 10px 10px 0 10px;
  height: 70px;
}

.rowItem {
  display: flex;
  align-items: center;
}

.ybase {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
}

.gridBtGroup {
  display: flex;
  justify-content: flex-end;
  /* padding-right: 30px; */
}

img {
  cursor: pointer;
  max-height: 45px;
}

.group-botton {
  display: grid;
  grid-template-columns: 100px 1fr 100px;
  margin-left: 0.8%;
  margin-right: 0.8%;
  width: 98.5%;
}

.hidden-button {
  width: 100%;
  border-radius: 3px;
  overflow: hidden;
}

#area-button {
  transition-duration: 2s;
}

.color-button {
  font-weight: 300;
  color: #fff9;
  background-color: #343a40;
}

.color-button:hover {
  color: #fff;
  background-color: #343a4099;
}

.color-button.selectable-button {
  width: 135px;
}

.move-button {
  background-color: #fff;
  z-index: 2;
}

.active-button,
.active-button:hover {
  font-weight: 400;
  color: #fff;
  background-color: #ff7100;
  border: 1px solid #fff;
  z-index: 1;
}

.active-button > span {
  border-bottom: 1px solid #fff;
}

.custom-select{
  min-width: 143px;
  margin-top: 5px;
}

.jsonBaseYear{
  width: 124px;
}

@media only screen and (max-width: 1450px) {

.row {
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-template-rows: 50px 50px;
}

.rowItem.dates{
  grid-row-start: 2;
  grid-column-start: 1;
  grid-column-end: 3;
  max-width: 750px;
  min-width: 665px;
}
  
}

@media only screen and (max-width: 768px) {
  .rowItem {
    align-items: center;
    grid-column: 2;
  }
  .row {
    grid-template-rows: 50px 50px 50px;
    grid-template-columns: 50% 50%;
    align-self: center;
    margin: 10px auto;
  }
  .yearSelect {
    margin: 10px auto;
     grid-row: 1;
    grid-column: 3;
  }

  .txtRevision {
    grid-row: 1;
    grid-column: 1;
    grid-column-end: 2;
  }
  .buttons {
    grid-row: 3;
    grid-column: 2;
  }

  .rowItem.dates{
  grid-row-start: 2;
  grid-column-start: 1;
  grid-column-end: 3;
  max-width: 750px;
  min-width: 665px;
}
}

@media only screen and (max-width: 680px) {

.row {
    grid-template-rows: 50px 50px 150px 50px;
  }


.rowItem.dates{
  display: grid;
  grid-template-rows: 50px 50px 50px;
  grid-template-columns: 50% 50%;
  grid-row-start: 3;
  max-width: 750px;
  min-width: 300px;
}

.label-start-week{
  grid-row-start: 2;
}

.select-start-week{
  grid-row-start: 2;
}

.rowItem{
  grid-column: 1;
  grid-column-end: 3;
}

.buttons {
  grid-row: 4;
    grid-column: 2;
  }

}


</style>

<style>
.cheetah-grid__tooltip-element__content {
  color: white;
  /* height: 6px; */
}
</style>
